export const toId = (v) => {
  if (!v) return "";
  if (typeof v === "string") return v;
  if (v._id) return String(v._id);
  if (v.id) return String(v.id);
  return String(v);
};

export const pickList = (res, keys = ["data"]) => {
  if (!res) return [];
  if (Array.isArray(res)) return res;
  for (const k of keys) {
    if (Array.isArray(res[k])) return res[k];
  }
  return [];
};

export const resolveYearName = (res) => {
  if (!res) return "";
  const y = res.academicYear || res.data || res;
  if (typeof y === "string") return y.trim();
  return (y.yearName || y.name || y.academicYear || y.label || "").toString().trim();
};

export const BATCH_STATUS_LABELS = {
  DRAFT: "Draft",
  GENERATED: "Generated",
  PUBLISHED: "Published",
  ARCHIVED: "Archived",
};

export const BATCH_STATUS_STYLES = {
  DRAFT: "bg-gray-100 text-gray-700",
  GENERATED: "bg-blue-100 text-blue-800",
  PUBLISHED: "bg-emerald-100 text-emerald-800",
  ARCHIVED: "bg-slate-200 text-slate-600",
};

export const RESULT_STATUS_COLORS = {
  PASS: "bg-emerald-100 text-emerald-800",
  FAIL: "bg-red-100 text-red-800",
  INCOMPLETE: "bg-amber-100 text-amber-800",
};

export const DEFAULT_GRADE_BANDS = [
  { minPercentage: 90, maxPercentage: 100, grade: "A+", label: "Outstanding", gradePoint: 10 },
  { minPercentage: 80, maxPercentage: 89.99, grade: "A", label: "Excellent", gradePoint: 9 },
  { minPercentage: 70, maxPercentage: 79.99, grade: "B+", label: "Very Good", gradePoint: 8 },
  { minPercentage: 60, maxPercentage: 69.99, grade: "B", label: "Good", gradePoint: 7 },
  { minPercentage: 50, maxPercentage: 59.99, grade: "C", label: "Satisfactory", gradePoint: 6 },
  { minPercentage: 40, maxPercentage: 49.99, grade: "D", label: "Needs Improvement", gradePoint: 5 },
  { minPercentage: 33, maxPercentage: 39.99, grade: "E", label: "Marginal", gradePoint: 4 },
  { minPercentage: 0, maxPercentage: 32.99, grade: "F", label: "Fail", gradePoint: 0 },
];

export const inputCls =
  "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-rose-500/40 focus:border-rose-400";
export const labelCls = "block text-xs font-medium text-gray-500 mb-1";
